export async function calculateChecksum(file: File): Promise<string> {
  const buffer = await file.arrayBuffer();

  const digest = await crypto.subtle.digest("SHA-256", buffer);

  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
